/* eslint-disable complexity */
import { Grid, Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Form, Formik } from 'formik';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { history } from '../../../helpers/history';
import {
  isDigitalSale,
  isRemoteDigitalSale
} from '../../../helpers/stepperFunctions';
import ConfirmDialog from '../../shared/Modals/ConfirmDialog';
import SegmentHeader from '../../shared/SegmentHeader';
import StepperButtons from '../../shared/StepperButtons';
import DocumentItem from '../SaleDetailPage/Document/Item';
const adblockDetector = require('adblock-detect');

class PortalEndSalePage extends Component {
  state = {
    dialogAdBlock: false
  };
  currentStep = this.props.routes.indexOf(this.props.location.pathname);
  initialStep = 0;

  componentDidMount() {
    !this.props.companyCode && this.props.fetchSessionData();
    this.props.setCurrentStep(this.currentStep);
    this.props.setNextStep(this.props.process, this.initialStep);
    adblockDetector(adBlockDetected => {
      if (adBlockDetected) {
        this.setState({ dialogAdBlock: true });
      }
    });
  }

  _onSubmit = (/* values */) => {
    if (this.props.saleNumber) {
      history.push(`/sales/${this.props.saleNumber}`);
    } else {
      history.push(this.props.routes[this.initialStep]);
    }
  };

  _handleCloseDialog = () => {
    this.setState({ dialogAdBlock: false });
  };

  captureVoucher = () => {
    const { saleNumber } = this.props;
    if (saleNumber) {
      history.push(`/digital-sale/capture-voucher/${this.props.saleNumber}`);
    }
  };

  render() {
    const {
      classes,
      showBin,
      isSecureSale,
      requestVoucherUrl,
      requestBinUrl,
      requestSecureUrl,
      requestPromissoryUrl,
      canGenPromissoryPDF,
      canGenInvoicePDF,
      canGenVoucherPDF,
      canGenSecurePDF,
      cardifArticleLayerOne,
      requestCardifUrl,
      requestCardifUrlLayerTwoUrl,
      requestPledgeUrl,
      canGenEnsuranceRequestPDF,
      canGeneratePledgePDF,
      voluntaryInsuranceLayerTwoArticleId,
      articles,
      voluntaryInsuranceLayerTwoName,
      voucherUrl,
      pdfVoucher,
      saleNumber,
      promissoryUrl,
      pdfPromissory,
      binUrl,
      pdfBin,
      secureUrl,
      pdfSecure,
      cardifUrl,
      pledgeArticleId,
      pdfRequestCardif,
      cardifLayerTwoUrl,
      pdfRequestCardifLayerTwo
    } = this.props;
    const initialValues = {};

    const hasCardifArticleLayerOne = articles.find(
      article => article.id === _get(cardifArticleLayerOne, 'id')
    );
    const hasCardifArticleLayerTwo = articles.find(
      article => article.id === voluntaryInsuranceLayerTwoArticleId
    );
    const hasGeneralGuarante = articles.find(
      article => article.id === pledgeArticleId
    );

    return (
      <div>
        <Paper className={classes.container}>
          <Formik
            initialValues={initialValues}
            validationSchema={{}}
            onSubmit={this._onSubmit}
            render={({ handleSubmit }) => (
              <Form className={classes.form}>
                <SegmentHeader className={classes.segmentHeader}>
                  VENTA FINALIZADA
                </SegmentHeader>
                <Grid container spacing={24} justify="center" direction="row">
                  {canGenVoucherPDF && (
                    <Grid item xs={12} md={3}>
                      <DocumentItem
                        url={voucherUrl}
                        loading={requestVoucherUrl}
                        fetchDocument={() => pdfVoucher(saleNumber)}
                        name={
                          isRemoteDigitalSale(this.props.process) ||
                          isDigitalSale(this.props.process)
                            ? 'Visualizar Voucher'
                            : 'Imprimir Voucher'
                        }
                      />
                    </Grid>
                  )}
                  {canGenPromissoryPDF && (
                    <Grid item xs={12} md={3}>
                      <DocumentItem
                        name={
                          isRemoteDigitalSale(this.props.process) ||
                          isDigitalSale(this.props.process)
                            ? 'Visualizar Pagaré'
                            : 'Imprimir Pagaré'
                        }
                        url={promissoryUrl}
                        loading={requestPromissoryUrl}
                        fetchDocument={() => pdfPromissory(saleNumber)}
                      />
                    </Grid>
                  )}
                  {showBin && canGenInvoicePDF && (
                    <Grid item xs={12} md={3}>
                      <DocumentItem
                        name="Generar BIN"
                        url={binUrl}
                        loading={requestBinUrl}
                        fetchDocument={() => pdfBin(saleNumber)}
                      />
                    </Grid>
                  )}
                  {isSecureSale && canGenSecurePDF && (
                    <Grid item xs={12} md={3}>
                      <DocumentItem
                        name={
                          isRemoteDigitalSale(this.props.process) ||
                          isDigitalSale(this.props.process)
                            ? 'Visualizar Fianza'
                            : 'Imprimir Fianza'
                        }
                        url={secureUrl}
                        loading={requestSecureUrl}
                        fetchDocument={() => pdfSecure(saleNumber)}
                      />
                    </Grid>
                  )}
                  {canGenEnsuranceRequestPDF &&
                    hasCardifArticleLayerOne &&
                    !isRemoteDigitalSale(this.props.process) && (
                      <Grid item xs={12} md={3}>
                        <DocumentItem
                          name={'Seguro cardif'}
                          url={cardifUrl}
                          loading={requestCardifUrl}
                          fetchDocument={() => pdfRequestCardif(saleNumber)}
                        />
                      </Grid>
                    )}
                  {canGenEnsuranceRequestPDF &&
                    hasCardifArticleLayerTwo &&
                    !isRemoteDigitalSale(this.props.process) && (
                      <Grid item xs={12} md={3}>
                        <DocumentItem
                          name={voluntaryInsuranceLayerTwoName}
                          url={cardifLayerTwoUrl}
                          loading={requestCardifUrlLayerTwoUrl}
                          fetchDocument={() =>
                            pdfRequestCardifLayerTwo(saleNumber)
                          }
                        />
                      </Grid>
                    )}
                  {canGeneratePledgePDF && hasGeneralGuarante && (
                    <Grid item xs={12} md={3}>
                      <DocumentItem
                        name="Pignoración"
                        url={this.props.pledgeUrl}
                        loading={requestPledgeUrl || !this.props.pledgeUrl}
                        fetchDocument={() => requestPledgeUrl(saleNumber)}
                      />
                    </Grid>
                  )}
                </Grid>
                <StepperButtons onSubmit={handleSubmit} />
              </Form>
            )}
          />
        </Paper>
        <ConfirmDialog
          open={this.state.dialogAdBlock}
          title="¡Bloqueador de ventanas emergentes detectado!"
          text="Recuerda desactivar tu adblocker para poder visualizar los documentos de la venta."
          buttonTextConfirm="de acuerdo"
          onConfirm={this._handleCloseDialog}
          onClose={this._handleCloseDialog}
        />
      </div>
    );
  }
}
const styles = theme => ({
  container: {},
  infoFieldGrid: {
    minHeight: 200,
    alignItems: 'center'
  },
  segmentHeader: {
    marginTop: 3 * theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit,
    '&:first-of-type': {
      marginTop: 0
    }
  },
  gridItem: {
    paddingTop: '0 !important',
    paddingBottom: '12 !important'
  },
  table: {
    marginTop: 3 * theme.spacing.unit,
    marginBottom: 3 * theme.spacing.unit
  },
  actionBar: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  mainButton: {
    alignSelf: 'flex-end',
    marginTop: 4 * theme.spacing.unit,
    paddingLeft: 8 * theme.spacing.unit,
    paddingRight: 8 * theme.spacing.unit
  },
  registerDateContainer: {
    marginTop: theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit
  },
  dialog: {
    width: '80%'
  },
  dialogButton: {
    color: theme.palette.text.primary,
    margin: 1 * theme.spacing.unit,
    marginTop: 0,
    paddingLeft: 8 * theme.spacing.unit,
    paddingRight: 8 * theme.spacing.unit
  }
});

PortalEndSalePage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withStyles(styles)(PortalEndSalePage);
